import { render, staticRenderFns } from "./Success-message.vue?vue&type=template&id=12a9af5c&scoped=true&"
import script from "./Success-message.vue?vue&type=script&lang=js&"
export * from "./Success-message.vue?vue&type=script&lang=js&"
import style0 from "./Success-message.vue?vue&type=style&index=0&id=12a9af5c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9af5c",
  null
  
)

export default component.exports